"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const TravelDates_translations_1 = require("./TravelDates.translations");
const moveDays = (days, firstDayOfWeek) => {
    const daysToMove = days.slice(0, firstDayOfWeek);
    const daysToLeave = days.slice(firstDayOfWeek);
    return [...daysToLeave, ...daysToMove];
};
const WeekDaysListWrapper = styled_components_1.default.ul(({ theme }) => theme.travelDates.weekDaysListCss, (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    pt: 1,
    px: 3,
    pb: 3,
    '.weekDay': {
        flex: 1,
    },
}));
const WeekDaysList = ({ firstDayOfWeek = 0 }) => {
    const { i18n: { language }, } = (0, next_i18next_1.useTranslation)();
    const weekDays = language === 'fr' ? TravelDates_translations_1.FR_WEEKDAYS_SHORT : TravelDates_translations_1.DE_WEEKDAYS_SHORT;
    return (react_1.default.createElement(WeekDaysListWrapper, { className: "week-day-list-wrapper" }, moveDays(weekDays, firstDayOfWeek).map(weekDay => (react_1.default.createElement("li", { className: "weekDay", key: weekDay }, weekDay)))));
};
exports.default = WeekDaysList;
//# sourceMappingURL=WeekDaysList.js.map